export default __webpack_public_path__ + "static/houseImage-74a83e14834a5f637e1d57d0bb172a28.png";